import { OrderOrderDetail } from "integration/generated/transactions/data-contracts";
import { ResponseProductType } from "../types/Product";
import { EMPTY_STRING } from "@/data/constants/marketing";
import { DisplayProduct } from "../types/ReturnOrder";

const normalizeImagePath = (path: string) => path.replaceAll("hclstore", "wcsstore").replace("wcsstore/wcsstore", "wcsstore");

export const getDisplayProducts = (order:OrderOrderDetail, products:ResponseProductType[] = [], staticHostSecure:string) => {
    const fallbackImage = `${staticHostSecure}/wcsstore/IntertoysSAS/images/NoImageIcon_sm.jpg`;
    return (
        order?.orderItem?.map((oItem) => {
            const product = products.find(
                (p) => p.id === oItem.xitem_parentCatalogEntryId
            );

            const imageSource =
                product?.thumbnail && product.thumbnail !== EMPTY_STRING
                    ? `${staticHostSecure}${normalizeImagePath(product.thumbnail)}`
                    : fallbackImage;

            return {
                partNumber: product?.partNumber ?? "",
                name: product?.name ?? "",
                href: product?.seo?.href ?? "",
                thumbnail: product?.thumbnail,
                imgSource: imageSource,
                quantity: oItem.quantity ? parseInt(oItem.quantity) : 0,
                id: oItem.orderItemId,
                orderPlacedDate: order.placedDate ?? "",
            } as DisplayProduct;
        }) ?? []
    );
}

export const checkOrderRevokeEligibility = (orderDate: string, revokeAnnounceThreshodInDays: number): boolean => {
    const order = new Date(orderDate);
    const today = new Date();

    // Remove time
    order.setHours(0, 0, 0, 0);
    today.setHours(0, 0, 0, 0);

    // Start counting from next day
    order.setDate(order.getDate() + revokeAnnounceThreshodInDays);

    return today <= order;
};